import axios from '@/base/api/axios'

export default {
  async list () {
    return (await axios.get('/api/sanctions/')).data
  },
}
